import styled, { css } from "styled-components";
import { theme } from "../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";

export const Wrapper = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    flex-shrink: 0;
    align-items: center;
    justify-content: space-between;
    padding: ${theme.space[5]}px ${theme.space[3]}px;
    border-bottom: 1px solid ${theme.colors.grey2};
    border-right: 1px solid ${theme.colors.grey2};
`;

export const MediaWrapper = styled.div<{ lightImage?: boolean; showBackground?: boolean }>`
    position: absolute;
    inset: 0;
    object-fit: cover;
    background-color: ${({ showBackground }) => (showBackground ? "rgba(0, 0, 0, 0.4)" : "transparent")};
    overflow: hidden;
    z-index: -1;

    ${({ lightImage }) =>
        lightImage
            ? css`
                  background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0) 36.87%);
              `
            : css`
                  background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 36.87%);
              `};

    img,
    video {
        position: absolute;
        flex-shrink: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        z-index: -1;
    }
`;

export const Text = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
    gap: ${theme.space[1] / 2}px;
`;

export const Title = styled.h2<{ lightImage?: boolean }>`
    margin: 0;
    padding: 0;
    font-family: ${theme.fonts.regular};
    font-size: 2.2rem;
    line-height: 1.27;
    text-align: center;
    text-shadow:
        0 15px 80px rgba(0, 0, 0, 0.04),
        0 4.5px 24.2px rgba(0, 0, 0, 0.05),
        0 1.9px 10.1px rgba(0, 0, 0, 0.03),
        0 0.7px 3.6px rgba(0, 0, 0, 0.02);
    text-transform: none;

    ${({ lightImage }) =>
        lightImage
            ? css`
                  color: ${theme.colors.primaryBlack};
              `
            : css`
                  color: ${theme.colors.primaryWhite};
              `}
`;

export const Description = styled.div<{ lightImage?: boolean }>`
    font-family: ${theme.fonts.base};
    font-size: 1.6rem;
    line-height: 1.5;
    text-align: center;
    text-shadow:
        0 15px 80px rgba(0, 0, 0, 0.04),
        0 4.5px 24.2px rgba(0, 0, 0, 0.05),
        0 1.9px 10.1px rgba(0, 0, 0, 0.03),
        0 0.7px 3.6px rgba(0, 0, 0, 0.02);

    ${({ lightImage }) =>
        lightImage
            ? css`
                  color: ${theme.colors.primaryBlack};
              `
            : css`
                  color: ${theme.colors.primaryWhite};
              `}
`;

export const EcoLabel = styled.div<{ lightImage?: boolean }>`
    padding: ${theme.space[1] / 2}px;
    font-family: ${theme.fonts.base};
    font-size: 1.4rem;
    line-height: 1.5;

    ${({ lightImage }) =>
        lightImage
            ? css`
                  color: ${theme.colors.primaryBlack};
              `
            : css`
                  color: ${theme.colors.primaryWhite};
              `}
`;

export const Actions = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0;
    gap: ${theme.space[2]}px;

    a,
    button {
        margin: 0;
    }
`;
